import { createEvent, createStore } from "effector";

import type { AppState } from "./types";

export const updateApp = createEvent<Partial<AppState>>();

export const $app = createStore<AppState>({
  isInitialized: false,
});

$app.on(updateApp, (state, payload) => ({
  ...state,
  ...payload,
}));
